import { __decorate, __param } from 'tslib';
import { ElementRef, Inject, Output, Directive, NgModule } from '@angular/core';
import { dragAndDropFrom } from '@taiga-ui/cdk/observables';
import { filter, map } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
let TuiDragDirective = class TuiDragDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.dragAndDropFrom$ = dragAndDropFrom(this.elementRef.nativeElement);
        this.start = this.dragAndDropFrom$.pipe(filter(({ stage }) => stage === 0 /* Start */), map(({ event }) => event));
        this.continues = this.dragAndDropFrom$.pipe(filter(({ stage }) => stage === 1 /* Continues */), map(({ event }) => event));
        this.end = this.dragAndDropFrom$.pipe(filter(({ stage }) => stage === 2 /* End */), map(({ event }) => event));
    }
};
TuiDragDirective.ɵfac = function TuiDragDirective_Factory(t) { return new (t || TuiDragDirective)(ɵngcc0.ɵɵdirectiveInject(ElementRef)); };
TuiDragDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiDragDirective, selectors: [["", "tuiDragStart", ""], ["", "tuiDragContinues", ""], ["", "tuiDragEnd", ""]], outputs: { start: "tuiDragStart", continues: "tuiDragContinues", end: "tuiDragEnd" } });
TuiDragDirective.ctorParameters = () => [
    { type: ElementRef, decorators: [{ type: Inject, args: [ElementRef,] }] }
];
__decorate([
    Output('tuiDragStart')
], TuiDragDirective.prototype, "start", void 0);
__decorate([
    Output('tuiDragContinues')
], TuiDragDirective.prototype, "continues", void 0);
__decorate([
    Output('tuiDragEnd')
], TuiDragDirective.prototype, "end", void 0);
TuiDragDirective = __decorate([ __param(0, Inject(ElementRef))
], TuiDragDirective);

let TuiDragModule = class TuiDragModule {
};
TuiDragModule.ɵfac = function TuiDragModule_Factory(t) { return new (t || TuiDragModule)(); };
TuiDragModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiDragModule });
TuiDragModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDragDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiDragStart], [tuiDragContinues], [tuiDragEnd]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef, decorators: [{
                type: Inject,
                args: [ElementRef]
            }] }]; }, { start: [{
            type: Output,
            args: ['tuiDragStart']
        }], continues: [{
            type: Output,
            args: ['tuiDragContinues']
        }], end: [{
            type: Output,
            args: ['tuiDragEnd']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDragModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiDragDirective],
                exports: [TuiDragDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiDragModule, { declarations: [TuiDragDirective], exports: [TuiDragDirective] }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiDragDirective, TuiDragModule };

